
import { ClientsTable } from "./ClientsTable";
import { ClientEmptyState } from "./ClientEmptyState";
import type { Client } from "@/types";

interface ClientsContentProps {
  clients: Client[];
  isLoading: boolean;
  onAddClient: () => void;
  onClientRemoved?: (clientId: string) => void;
}

export function ClientsContent({ 
  clients, 
  isLoading, 
  onAddClient,
  onClientRemoved 
}: ClientsContentProps) {
  return (
    <div className="glass rounded-xl animate-slide-in">
      {isLoading ? (
        <div className="p-8 text-center text-white/70">Loading...</div>
      ) : clients.length === 0 ? (
        <ClientEmptyState onAddClient={onAddClient} />
      ) : (
        <ClientsTable 
          clients={clients} 
          isLoading={false} 
          onClientRemoved={onClientRemoved}
        />
      )}
    </div>
  );
}
